var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckout = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "-15 -30 299 443"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "checkout_svg__a",
  d: "M0 0h400v600H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "checkout_svg__c",
  d: "M.743.918h48.799v190.176H.742z"
}), /*#__PURE__*/React.createElement("path", {
  id: "checkout_svg__e",
  d: "M.562.43h98.18v192.587H.562z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-58 -157)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "checkout_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#checkout_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#checkout_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7F7",
  fillRule: "nonzero",
  d: "M295.79 278.913l13.555-47.4 10.914 3.122-13.554 47.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  fillRule: "nonzero",
  d: "M295.79 278.913l13.555-47.4 4.515 1.292-13.555 47.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  fillRule: "nonzero",
  d: "M304.509 248.421l4.835-16.907 10.915 3.12-4.835 16.908z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D82E2E",
  fillRule: "nonzero",
  d: "M303.814 243.438l22.654-79.217 14.834 4.242-22.654 79.217z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF7D7D",
  fillRule: "nonzero",
  d: "M309.677 245.115l22.652-79.218 6.517 1.863-22.654 79.217z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M235.434 461.412l47.905-64.689 28.203-105.993 12.78 1.944-16.07 120.059-79.5 113.241s-5.327-34.593 6.682-64.562",
  fill: "#3A3A3A",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M325.63 290.1s12.352-23.932 4.234-43.2c-8.116-19.269-31.946-8.456-31.946-8.456l-.768 3.901s13.43-2.853 19.723 2.96l-.717 1.406s-8.644-3.414-17.895-1.306l-.723 4.098s10.255 1.39 16.197 2.935l.252 2.013s-9.647-2.356-17.322-.607l.092 4.948s6.145-1.194 15.73 1.799l-.366 1.118s-8.106-1.052-14.727 1.699l-.355 2.98s6.37-.21 13.806 2.444c0 0-9.17 16.996 2.098 23.745 11.268 6.75 12.686-2.477 12.686-2.477",
  fill: "#E2BB9F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7F7",
  fillRule: "nonzero",
  d: "M106.192 271.5l-14.427-47.141-10.854 3.322 14.426 47.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  fillRule: "nonzero",
  d: "M106.192 271.5l-14.427-47.141-4.492 1.374 14.427 47.141z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  fillRule: "nonzero",
  d: "M96.911 241.174l-5.146-16.815-10.855 3.322 5.146 16.815z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D82E2E",
  fillRule: "nonzero",
  d: "M97.514 236.18l-24.111-78.788-14.752 4.515 24.11 78.786z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF7D7D",
  fillRule: "nonzero",
  d: "M91.684 237.963l-24.111-78.786-6.48 1.982 24.111 78.788z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.44 259.427s21.67 12.11 15.296 63.1h-6.798s4.673-62.887-43.767-70.535l35.268 7.435z",
  fill: "#2E83C0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.568 445.495l-21.708 17.807-9.242 149.726s71.485 23.924 118.928-.723l-12.272-88.201-7.013-64.329-14.61-14.61-54.083.33z",
  fill: "#4E4E4E",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.285 378.353s2.544 40.184-12.717 67.142c0 0 35.382 22.46 58.758 5.513 0 0-9.102-30.129-3.506-63.7l-42.535-8.955z",
  fill: "#F4D8BD",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.403 442.242l.544-1.456c-1.856-9.668-3.89-25.26-2.453-42.686l-41.054-12.394a178.35 178.35 0 01-.06 3.951l43.023 52.585z",
  fill: "#E2BB9F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.58 284.76s41.54 9.326 43.574 63.243l-8.138 11.53s-1.865-36.115-35.436-74.773",
  fill: "#F4D8BD",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.963 361.906v32.554l82.555 37.368s21.89-29.907 18.498-99.763c-3.391-69.855-93.763-60.021-109.362-23.398-15.598 36.623 8.309 53.24 8.309 53.24",
  fill: "#F4D8BD",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4D8BD",
  fillRule: "nonzero",
  d: "M280.49 354.446L290.155 387l-13.226 9.156-14.75-8.647z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2BB9F",
  fillRule: "nonzero",
  d: "M290.154 387h-22.38l.508-8.138-6.104 8.647 14.751 8.647z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.984 359.787c0-8.568-6.947-15.514-15.514-15.514-8.568 0-15.514 6.946-15.514 15.514 0 6.475 3.97 12.018 9.605 14.343.312 3.288 3.048 5.87 6.418 5.87 3.54 0 6.408-2.844 6.467-6.37 5.06-2.555 8.538-7.787 8.538-13.843",
  fill: "#F4D8BD",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.434 345.969s8.477-5.426 15.26 5.764l24.754-27.128 1.1-21.451s26.487-7.652 64.346 11.277c1.358.68 7.46-.677 7.46-.677s-10.51-39.675-68.837-35.267c-58.326 4.409-49.51 56.63-44.083 67.482",
  fill: "#8E6042",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.759 356.48c0-.762-4.578-6.357-7.121-6.357s-7.376 2.797-6.613 11.7c.763 8.9 8.647 8.391 8.647 8.391l3.815 2.035s-5.595-6.867-4.832-10.427c.763-3.56 6.104-5.341 6.104-5.341",
  fill: "#E2BB9F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.562 366.662c2.511 3.835 7.11 3.552 7.11 3.552l3.815 2.036s-2.463-3.032-3.896-6.11c-1.72 1.06-4.384 1.263-7.03.522M171.638 350.122c-1.15 0-2.767.582-4.126 2.034 1.836 1.348 4.947 3.923 6.724 7.022 1.836-1.795 4.523-2.698 4.523-2.698 0-.762-4.578-6.358-7.121-6.358",
  fill: "#CEA284",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M272.521 349.02l3.187 10.236s-10.226 13.15-28.927 4.091l7.304-2.046s-19.285-1.46-28.636-21.622l17.825-4.675 29.247 14.016z",
  fill: "#E2BB9F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8E6042",
  fillRule: "nonzero",
  d: "M224.28 339.094l19.286-2.045 28.955 11.971 4.357-6.42-33.896-11.687z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.835 350.052s11.688-.145 16.656 8.036l-.146-5.552s-7.597-7.158-16.51-2.484",
  fill: "#202020",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(214.187 443.56)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "checkout_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#checkout_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.743 74.115L10.605.918l12.053 11.25 26.884 187.594s-12.274 6.43-25.715 7.013l-10.52-23.376L.744 74.115z",
  fill: "#E7F438",
  fillRule: "nonzero",
  mask: "url(#checkout_svg__d)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(133.428 441.637)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "checkout_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#checkout_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  d: "M36.357.43l45.145 75.608 17.24 107.53-8.182 28.052S37.38 219.217.562 201.1L11.519 21.396 36.357.43z",
  fill: "#E7F438",
  fillRule: "nonzero",
  mask: "url(#checkout_svg__f)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M182.934 458.942s25.422 12.273 41.64 0v-7.89s-21.916 7.014-44.708-.875l3.068 8.765z",
  fill: "#3A3A3A",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.139 461.426s7.305 31.705 6.648 56.907c-.659 25.202-10.958 31.338-10.958 31.338s-5.405-32.288 4.31-88.245",
  fill: "#4E4E4E",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.34 582.127c16.72-1.69 26.806-5.16 31.58-7.245l-4.1-28.608c-.04.014-.077.024-.117.037-9.266 2.954-19.917 4.721-30.825 5.702l3.463 30.114z",
  fill: "#BEBF91",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.756 577.285c37.459 6.763 64.242 6.69 82.458 4.532l-4.802-29.946c-31.764 3.082-66.183-.75-75.277-1.895-1.495-.189-2.306-.305-2.306-.305l-3.283 1.943-1.47 24.111 4.68 1.56z",
  fill: "#BEBF91",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.93 517.675l14.318 111.622s-1.169-72.467-14.318-111.622",
  fill: "#D2D613",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.472 457.408s16.582 53.255 13.076 95.917l25.13 1.168s-1.17-74.804-18.118-115.713l-20.088 18.628z",
  fill: "#BEBF91",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D613",
  fillRule: "nonzero",
  d: "M147.139 461.426l67.791 56.249-59.902-62.824z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBFF66",
  fillRule: "nonzero",
  d: "M173.29 431.913l-20.819 25.495 62.459 60.267z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.91 473.845c.585 5.26 13.442 75.972 13.442 75.972l9.35-3.506-12.857-90.583-9.935 18.117z",
  fill: "#BEBF91",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D613",
  fillRule: "nonzero",
  d: "M236.845 455.728l1.315 10.373-23.23 51.574z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBFF66",
  fillRule: "nonzero",
  d: "M214.93 517.675l9.017-76.889 12.899 14.942z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.249 350.243l-5.699 44.268 86.785 40.324s10.04-14.243 11.594-38.679l-26.935-10.849-7.012 8.328-58.733-43.392z",
  fill: "#8E6042",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2BB9F",
  fillRule: "nonzero",
  d: "M287.659 349.87l-5.092 4.067-.508 5.596 6.649-9.42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8E6042",
  fillRule: "nonzero",
  d: "M284.81 345.523l-2.243 8.414 6.783-2.374.847-3.56z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.501 398.164l16.948 6.43s-7.597 11.978-16.948-6.43",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.547 303.154s13.44-37.943 52.304-29.469l-9.058 4.091s15.78-4.675 36.234 17.533l-9.936-2.046s20.747 11.98 15.78 37.986c0 0-8.182-14.318-30.975-16.07l-54.349-12.025z",
  fill: "#9E6B4F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.735 354.714c0 13.2 10.7 23.901 23.9 23.901 13.202 0 23.902-10.701 23.902-23.901s-10.7-23.901-23.901-23.901c-13.2 0-23.901 10.701-23.901 23.9",
  fill: "#2E83C0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.75 354.714c0 8.318 6.744 15.061 15.062 15.061s15.061-6.743 15.061-15.061-6.743-15.062-15.061-15.062-15.062 6.744-15.062 15.062M182.779 333.362s6.374-82.858 72.66-73.935c0 0-19.12-9.136-35.267-7.436-16.147 1.7-42.067 37.392-43.341 81.584l5.948-.213z",
  fill: "#5C9ECE",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.302 461.922l-42.19-68.837L89.77 284.482l-12.919.404 1.615 121.119 65.404 121.926s11.776-34.82 3.432-66.009",
  fill: "#4E4E4E",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.564 283.236s-12.792-23.7-5.032-43.115c7.76-19.415 31.786-9.045 31.786-9.045l.84 3.887s-13.48-2.604-19.665 3.324l.74 1.391s8.581-3.571 17.87-1.635l.798 4.084s-10.228 1.58-16.14 3.233l-.215 2.017s9.602-2.534 17.308-.927v4.95s-6.167-1.08-15.695 2.088l.387 1.111s8.086-1.2 14.756 1.427l.411 2.973s-6.374-.091-13.76 2.7c0 0 9.483 16.823-1.66 23.78-11.142 6.955-12.73-2.243-12.73-2.243",
  fill: "#F4D8BD",
  fillRule: "nonzero"
})))));
export default SvgCheckout;